import './component-cart.scss'
import './component-cart-items.scss'
import './component-discounts.scss'
import debounce from 'lodash/debounce';
import fetchConfig from '@/entrypoints/helpers/fetchConfig';
import CartCrossSellCarousel from '@/modules/cart-cross-sell-carousel';
class CartItems extends HTMLElement {
    constructor() {
        super();

        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
            .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
        const target = event.target;
        if (!target.matches('input[name="updates[]"]')) return;

        this.updateQuantity(
            target.dataset.index,
            target.value,
            target.getAttribute('name')
        );
    }

    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents'
            },
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items')?.dataset?.id,
                selector: '.js-related-cross-sell-context'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.js-contents'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer')?.dataset?.id,
                selector: '.js-evergreen-cross-sell-context'
            }
        ];
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(`${window.routes.cart_change_url}`, {...fetchConfig.init(), ...{ body }})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                    elementToReplace.innerHTML =
                        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));

                this.updateLiveRegions(line, parsedState.item_count);
                this.postRenderContents();
                const lineItem =  document.getElementById(`CartItem-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
                this.disableLoading();
            }).catch(() => {
                this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
                document.getElementById('cart-errors').textContent = window.cartStrings.error;
                this.disableLoading();
            });
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            document.getElementById(`Line-item-error-${line}`)
                .querySelector('.cart-item__error-text')
                .innerHTML = window.cartStrings.quantityError.replace(
                    '[quantity]',
                    document.getElementById(`Quantity-${line}`).value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        document.getElementById('main-cart-items').querySelector('.cart__items').classList.add('cart__items--disabled');
        this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
        document.getElementById('main-cart-items').querySelector('.cart__items').classList.remove('cart__items--disabled');
    }

    postRenderContents() {
        const carousels = document.querySelectorAll('.js-cart-cross-sell-carousel');
        if (!carousels.length) return;

        carousels.forEach(el => new CartCrossSellCarousel(el));
    }
}

class CartRemoveButton extends HTMLElement  {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            this.closest('cart-items').updateQuantity(this.dataset.index, 0);
        });
    }
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

export {
    CartItems,
    CartRemoveButton,
    QuantityInput,
}
